import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,5.25 c -0.4141,0 -0.75,0.3358204 -0.75,0.75 v 5.25 H 6 c -0.4140596,0 -0.75,0.3358 -0.75,0.75 0,0.4142 0.3359404,0.75 0.75,0.75 h 5.25 V 18 c 0,0.4142 0.3359,0.75 0.75,0.75 0.4141,0 0.75,-0.3358 0.75,-0.75 V 12.75 H 18 c 0.1875,0 0.358935,-0.06969 0.490234,-0.183594 C 18.648934,12.429006 18.75,12.2266 18.75,12 18.75,11.5858 18.4141,11.25 18,11.25 H 12.75 V 6 C 12.75,5.5858204 12.4141,5.25 12,5.25 Z"
	})]
});
export default SvgPlusLine;
